import React from 'react';

import { GUIDE_TEXT_MAX_WIDTH } from '@backrs_ui/grow-ui/src/components/GuidePage';

import { Box, SxProps, Theme, Typography } from '@mui/material';

type SubsectionHeaderProps = Readonly<{
  title?: string;
  subtitle?: string;
}>;

/** Title and intro copy for a block within a guide section. */
export const SubsectionHeader: React.FC<SubsectionHeaderProps> = ({ title, subtitle }) => (
  <Box sx={headerSx}>
    {title && (
      <Typography variant="text-xl-semibold" sx={titleSx}>
        {title}
      </Typography>
    )}
    {subtitle && (
      <Typography variant="text-md-regular" sx={subtitleSx}>
        {subtitle}
      </Typography>
    )}
  </Box>
);

const headerSx: SxProps<Theme> = ({ backrs }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: backrs.spacing['spacing-sm'],
});

const titleSx: SxProps<Theme> = ({ backrs }) => ({
  color: backrs.colors['Colors/Text/text-primary'],
});

const subtitleSx: SxProps<Theme> = ({ backrs }) => ({
  color: backrs.colors['Colors/Text/text-tertiary'],
  maxWidth: GUIDE_TEXT_MAX_WIDTH,
});
